import AssessmentResultView from './AssessmentResultView'
export default AssessmentResultView
